export function generateSlug(title, id) {
  if (!title || typeof title !== 'string') return 'unknown-video';

  const baseSlug = title
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, '+')
    .replace(/\++/g, '+')
    .replace(/^\+|\+$/g, '') || 'unknown-video';

  const uniquePart = id ? id.slice(-6) : Math.random().toString(36).substring(2, 8);

  return `${baseSlug}+${uniquePart}`;
}
